import React from 'react';
export const LOCStat = ({ value, label }) => {
    return (React.createElement("div", { className: "flex flex-col md:min-w-60" },
        React.createElement("div", { className: "text-gray-30 mb-2 font-medium leading-4 text-xs" }, label),
        React.createElement("div", { className: "bg-gray-80 md:py-4 md:px-3.5 rounded text-gray-10" },
            React.createElement("span", { className: "font-medium text-2xl md:text-[2.25rem] leading-[2.625rem]" }, value))));
};
